import { goBack } from 'react-router-redux';
import { UPDATE_CATEGORY_SUCCESS } from '../actions/update-category';
import { DELETE_POST_SUCCESS } from '../actions/delete-post';
import { replace } from '../services/router-utils';
import { getCurrentLocation } from '../selectors/location-history-selectors';
import { getPost } from '../selectors/post-selectors';
import { isOneApp } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';

const handlePostDeleteRedirect = (action, store) => {
  const state = store.getState();
  const { pathname } = getCurrentLocation(store.getState());
  const post = getPost(state, action.payload);
  const isPostPage = post && post.slug && pathname.indexOf(`/${post.slug}`) > -1;
  if (isPostPage) {
    const routerAction = isOneApp(store.getState()) ? goBack() : replace('/');
    store.dispatch(routerAction);
  }
};

const redirectMiddleware = store => next => action => {
  switch (action.type) {
    case UPDATE_CATEGORY_SUCCESS:
      store.dispatch(replace('/'));
      break;
    case DELETE_POST_SUCCESS:
      handlePostDeleteRedirect(action, store);
      break;
    default:
      break;
  }
  return next(action);
};

export default redirectMiddleware;
